<template>
  <div class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-center justify-center min-h-screen">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-black opacity-50"></div>
      </div>
      <div class="bg-white rounded-lg overflow-hidden shadow-xl z-50">
        <h2 class="text-gray-700 font-bold text-md px-5 py-4 mb-0 mt-0">
          Registro de Sucursal / Almacen
        </h2>
        <form
          class="w-full px-5 pb-5 grid md:grid-cols-2 gap-x-4"
          @submit.prevent
        >
          <label class="block mb-4">
            <span class="text-sm text-gray-600 mb-1 block"> Empresas </span>
            <SelectOptionsCompany @send-data="getSelectOptions" />
          </label>
          <label class="block mb-4">
            <span class="text-sm text-gray-600 mb-1 block"> Razón social </span>
            <input
              type="text"
              class="py-2 px-2 text-sm bg-white border outline-none rounded-lg shadow-sm text-gray-600 w-full"
              v-model="dataForm.nameStore"
              placeholder="Razon social..."
            />
          </label>
          <label class="mb-3 block">
            <span class="text-sm text-gray-600 mb-1 block"> Dirección </span>
            <input
              type="text"
              class="py-2 px-2 text-sm bg-white border outline-none rounded-lg shadow-sm text-gray-600 w-full"
              v-model="dataForm.adderss"
              placeholder="Dirección..."
            />
          </label>
          <label class="mb-3 block">
            <span class="text-sm text-gray-600 mb-1 block">
              Celular / Teléfono
            </span>
            <input
              type="text"
              class="py-2 px-2 text-sm bg-white border outline-none rounded-lg shadow-sm text-gray-600 w-full"
              v-model="dataForm.cellPhone"
              placeholder="Celular..."
            />
          </label>

          <label class="mb-3 block">
            <span class="text-sm text-gray-600 mb-1 block">
              Nombre Comercial
            </span>
            <input
              type="text"
              class="py-2 px-2 text-sm bg-white border outline-none rounded-lg shadow-sm text-gray-600 w-full"
              v-model="dataForm.tradeName"
              placeholder="Nombre Comercial"
            />
          </label>
          <label class="mb-3 block">
            <span class="text-sm text-gray-600 mb-1 block"> RNC </span>
            <input
              type="text"
              class="py-2 px-2 text-sm bg-white border outline-none rounded-lg shadow-sm text-gray-600 w-full"
              v-model="dataForm.rnc"
              placeholder="RNC"
            />
          </label>
          <label class="mb-3 block">
            <span class="text-sm text-gray-600 mb-1 block"> Provincia </span>
            <input
              type="text"
              class="py-2 px-2 text-sm bg-white border outline-none rounded-lg shadow-sm text-gray-600 w-full"
              v-model="dataForm.province"
              placeholder="Provincia..."
            />
          </label>
          <label class="mb-3 block">
            <span class="text-sm text-gray-600 mb-1 block">
              Municipalidad
            </span>
            <input
              type="text"
              class="py-2 px-2 text-sm bg-white border outline-none rounded-lg shadow-sm text-gray-600 w-full"
              v-model="dataForm.municipality"
              placeholder="Municipalidad..."
            />
          </label>
          <label class="mb-3 block">
            <span class="text-sm text-gray-600 mb-1 block">
              Correo Electrónico
            </span>
            <input
              type="text"
              class="py-2 px-2 text-sm bg-white border outline-none rounded-lg shadow-sm text-gray-600 w-full"
              v-model="dataForm.email"
              placeholder="Correo..."
            />
          </label>

          <div
            class="lg:col-span-4 md:col-span-2 grid gap-4 md:grid-cols-2 lg:grid-cols-4"
          >
            <span class="lg:col-span-4 md:col-span-2 font-semibold"
              >Certificado Digital</span
            >
            <label class="mb-3 block">
              <span class="text-sm text-gray-600 mb-1 block"
                >Nombre del certificado
              </span>
              <input
                type="text"
                class="py-2 px-2 text-sm bg-white border outline-none rounded-lg shadow-sm text-gray-600 w-full"
                placeholder="Nombre del certificado"
                v-model="certificate.name"
              />
            </label>
            <div class="w-full">
              <span class="text-sm text-gray-600 mb-1 block">
                Subir certificado
              </span>
              <label
                for="dropzone-file-cert"
                class="flex flex-col items-center justify-center w-full h-10 border-2 border-gray-200 border-dashed rounded-lg cursor-pointer bg-white dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
              >
                <div class="flex items-center justify-between w-full px-4">
                  <div class="w-4 h-4 mr-4">
                    <svg class="w-4 h-4 text-gray-400">
                      <use href="@/assets/svg/icon.svg#upload" />
                    </svg>
                  </div>
                  <p class="text-[12px] text-gray-500 dark:text-gray-400">
                    <span class="font-semibold">Selecciona un archivo</span>
                  </p>
                </div>
                <input
                  id="dropzone-file-cert"
                  type="file"
                  class="hidden"
                  ref="certificateFile"
                  @change="selectFileCertificate"
                />
              </label>
            </div>

            <label class="mb-3 block">
              <span class="text-sm text-gray-600 mb-1 block"> Contraseña </span>
              <input
                type="text"
                class="py-2 px-2 text-sm bg-white border outline-none rounded-lg shadow-sm text-gray-600 w-full"
                placeholder="Contraseña"
                v-model="certificate.password"
              />
            </label>
          </div>

          <div class="flex md:col-span-2">
            <button
              class="bg-red-500 text-white px-2 py-2 font-semibold text-sm rounded-lg hover:shadow-sm hover:shadow-red-600 active:scale-95 w-full mt-3"
              @click="isActive"
              type="button"
            >
              Cancelar
            </button>
            <button
              class="bg-blue-500 text-white px-2 py-2 font-semibold text-sm rounded-lg hover:shadow-sm hover:shadow-blue-600 active:scale-95 w-full mt-3 ml-3"
              @click="insert"
            >
              Registrar
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import SelectOptionsCompany from "@/components/Company/SelectOptionsCompany.vue";
import { ref } from "vue";
import { confirmationOfRecord, errorActions } from "@/alerts";
import axios from "../../../api";
export default {
  name: "RegisterCompany",
  components: {
    SelectOptionsCompany,
  },
  props: {
    activeModal: {
      type: Function,
      required: true,
    },
    getdata: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    function isActive() {
      props.activeModal(true);
    }

    const dataForm = ref({
      nameStore: "",
      adderss: "",
      cellPhone: "",
      idCompany: 0,

      tradeName: "",
      rnc: "",
      province: "",
      municipality: "",
      email: "",
    });

    const certificate = ref({
      name: "",
      extension: "",
      file: "",
      password: "",
    });

    const certificateFile = ref("");

    //recepcion de datos desde el select hijo
    const getSelectOptions = (data) => {
      dataForm.value.idCompany = data;
    };

    const selectFileCertificate = async () => {
      await certificateFile.value.files;
      await uploadCertificate();
    };

    const insert = async () => {
      if (
        dataForm.value.idCompany === 0 ||
        dataForm.value.idCompany === undefined
      ) {
        errorActions("Selecciona una empresa");
        return;
      }
      if (dataForm.value.nameStore.trim().length < 4) {
        errorActions(
          "Lo sentimos, no podemos registrar el sucursal, ingresa una sucursal mas descriptiva"
        );
        return;
      }
      const response = await axios
        .post(
          "sucursales",
          {
            idempresa: dataForm.value.idCompany,
            razon_social: dataForm.value.nameStore,
            direccion: dataForm.value.adderss,
            celular: dataForm.value.cellPhone,

            tradeName: dataForm.value.tradeName,
            rnc: dataForm.value.rnc,
            province: dataForm.value.province,
            municipality: dataForm.value.municipality,
            email: dataForm.value.email,

            certificate_name: certificate.value.name,
            certificate_extension: certificate.value.extension,
            certificate_file: certificate.value.file,
            certificate_password: certificate.value.password,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .catch(function (error) {
          errorActions(error);
        });
      const data = await response.data;
      if (data.msg === true) {
        confirmationOfRecord(dataForm.value.nameStore);
        props.getdata();
      } else if (data.msg === "Request failed with status code 500") {
        errorActions("Request failed with status code 500");
      } else if (data.msg === "idNull") {
        errorActions(
          "No podemos ubicar a la empresa para poder registrar su sucursal"
        );
      } else {
        errorActions(
          "Lo sentimos no pudimos realizar el resgitro de la sucursal"
        );
      }
    };

    const uploadCertificate = async () => {
      const formData = new FormData();
      formData.append("certificate", certificateFile.value.files[0]);
      const response = await axios
        .post(`sucursales/upload-certificate`, formData, {
          "Content-Type": "multipart/form-data",
        })
        .catch((error) => {
          errorActions(error);
        });
      const dataresponse = await response.data;
      if (dataresponse.msg === true) {
        confirmationOfRecord("El certificado ");
        certificate.value.file = dataresponse.file || null;
        certificate.value.extension = dataresponse.extension || null;
      } else if (dataresponse.msg === "error") {
        errorActions("Error al guardar certificado");
      }
    };

    return {
      isActive,
      dataForm,
      certificate,
      certificateFile,
      insert,
      getSelectOptions,
      selectFileCertificate,
    };
  },
};
</script>
